import { AxiosInstance } from 'axios'
import { IJsonApiSerializer } from '../JsonApiSerializer'

class GuideReportService {
  public httpClient: AxiosInstance
  public serializer: IJsonApiSerializer

  constructor(httpClient: AxiosInstance, serializer: IJsonApiSerializer) {
    this.httpClient = httpClient
    this.serializer = serializer
  }

  public async getGuideReports(params, page) {
    const { data } = await this.httpClient.get(`/agent/api/guide_reports?page=${page}`, { params })
    const guide_reports = this.serializer.parseResourceData(
      data.guide_reports.guide_reports,
      data.guide_reports.guide_reports.data
    )
    const pagination = data.guide_reports.guide_reports.meta

    return { guide_reports, pagination }
  }

  public async getGuideReport(id: number) {
    const { data } = await this.httpClient.get(`/agent/api/guide_reports/${id}`)
    const guide_report = this.serializer.parseResourceData(
      data.guide_report,
      data.guide_report.data
    )

    return { guide_report }
  }

  // progress を渡すと、そのステータスで保存した後の値を試算して返す(受領拒否なら0、解除なら通常計算)
  public async calcPayment(
    guideReportId: number,
    numbers: { num_of_adults: number; num_of_children: number; num_of_infants: number },
    progress?: string
  ) {
    const { data } = await this.httpClient.get(
      `/agent/api/guide_reports/${guideReportId}/calc_payment`,
      {
        params: { ...numbers, progress },
      }
    )

    return data as {
      guide_fee: number
      calculated_special_activity_fee: number
      calculated_large_group_fee: number
    }
  }

  // 報告
  public async createGuideReport(formData) {
    const { data } = await this.httpClient.post(`/agent/api/guide_reports`, formData)
    const { flush } = data
    const guide_report = this.serializer.parseResourceData(
      data.guide_report,
      data.guide_report.data
    )

    return { guide_report, flush }
  }

  public async updateGuideReport(guideReport, formData) {
    const { data } = await this.httpClient.put(
      `/agent/api/guide_reports/${guideReport.id}`,
      formData
    )
    const { flush } = data
    const guide_report = this.serializer.parseResourceData(
      data.guide_report,
      data.guide_report.data
    )

    return { guide_report, flush }
  }
}

export default GuideReportService
